var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57895 0.679688C0.706919 0.679688 0 1.38661 0 2.25863C0 3.13066 0.706919 3.83758 1.57895 3.83758C2.45098 3.83758 3.15789 3.13066 3.15789 2.25863C3.15789 1.38661 2.45098 0.679688 1.57895 0.679688ZM5.52632 1.46916C5.0903 1.46916 4.73684 1.82262 4.73684 2.25863C4.73684 2.69465 5.0903 3.04811 5.52632 3.04811H14.2105C14.6465 3.04811 15 2.69465 15 2.25863C15 1.82262 14.6465 1.46916 14.2105 1.46916H5.52632Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57895 5.41901C0.706919 5.41901 0 6.12593 0 6.99795C0 7.86998 0.706919 8.5769 1.57895 8.5769C2.45098 8.5769 3.15789 7.86998 3.15789 6.99795C3.15789 6.12593 2.45098 5.41901 1.57895 5.41901ZM5.52632 6.20848C5.0903 6.20848 4.73684 6.56194 4.73684 6.99795C4.73684 7.43397 5.0903 7.78743 5.52632 7.78743H14.2105C14.6465 7.78743 15 7.43397 15 6.99795C15 6.56194 14.6465 6.20848 14.2105 6.20848H5.52632Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57895 10.1583C0.706919 10.1583 0 10.8652 0 11.7373C0 12.6093 0.706919 13.3162 1.57895 13.3162C2.45098 13.3162 3.15789 12.6093 3.15789 11.7373C3.15789 10.8652 2.45098 10.1583 1.57895 10.1583ZM5.52632 10.9478C5.0903 10.9478 4.73684 11.3013 4.73684 11.7373C4.73684 12.1733 5.0903 12.5267 5.52632 12.5267H14.2105C14.6465 12.5267 15 12.1733 15 11.7373C15 11.3013 14.6465 10.9478 14.2105 10.9478H5.52632Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.96a426138b96691b77561313c549f635.svg";
export { ForwardRef as ReactComponent };